/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */

export class AndroidAppMgrDef {
    public readonly APPLICATION_LIST_MAX_LENGTH = 100;  // リストに登録できるアプリ数
}

/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
